import { Bones, Box, Text, Grid } from '@simplywallst/ui-core';

export const TileSkeleton = () => (
  <Box borderRadius="x1" boxShadow="strongBorder" height={370}>
    <Grid justifyContent="center">
      {/* <Box width="130px" padding="x1" paddingSm="x0" marginTopSm="x1"> */}
      <Box
        marginTop="x3"
        width="110px"
        height="110px"
        borderRadius="x10"
        backgroundColor="darkerGray"
      />
    </Grid>
    <Bones margin="x1_5" />
    <Bones margin="x1_5" />
    <Grid templateColumns="45% 1fr 1fr" alignItems="center">
      <Box margin="x1_5">
        <Text typography="tiny" color="whiteRGBA" opacity={0.5}>
          Price
        </Text>
        <Bones />
      </Box>
      <Box margin="x1_5">
        <Text typography="tiny" color="whiteRGBA" opacity={0.5}>
          7D
        </Text>
        <Bones />
      </Box>
      <Box margin="x1_5">
        <Text typography="tiny" color="whiteRGBA" opacity={0.5}>
          1Y
        </Text>
        <Bones />
      </Box>
    </Grid>
    <Grid templateColumns="45% 1fr 1fr" alignItems="center">
      <Box margin="x1_5">
        <Text typography="tiny" color="whiteRGBA" opacity={0.5}>
          Mkt cap
        </Text>
        <Bones />
      </Box>
      <Box margin="x1_5">
        <Text typography="tiny" color="whiteRGBA" opacity={0.5}>
          PS
        </Text>
        <Bones />
      </Box>
      <Box margin="x1_5">
        <Text typography="tiny" color="whiteRGBA" opacity={0.5}>
          E.Growth
        </Text>
        <Bones />
      </Box>
    </Grid>
    <Box margin="x1_5">
      <Text typography="tiny" color="whiteRGBA" opacity={0.5}>
        Analysts Target
      </Text>
      <Bones maxWidth="70%" />
    </Box>
  </Box>
);
